import React from 'react';

import { useMinimalCart } from 'features/cart/hooks/use-minimal-cart';
import { useMinimalCartUi } from 'features/cart/hooks/use-minimal-cart-ui';
import { MenuItemUnavailable } from 'features/menu/components/menu-item-unavailable';
import { MenuProductSkeleton } from 'features/menu/components/menu-product-skeleton';
import { ProductDetail } from 'features/menu/components/product-detail';
import { ProductWizardProvider } from 'features/menu/components/product-wizard';
import { useMenuScroll } from 'features/menu/hooks/use-menu-scroll';
import { useLogMenuContent } from 'features/menu/pages/menu-object-page/use-log-menu-content';

import { CardModal } from 'components/card-modal';
import { useRoute } from 'hooks/navigation/use-route';
import { useCart } from 'hooks/use-cart';
import { useUnifiedMenuContext } from 'state/unified-menu/unified-menu-context';
import { useMenuQueryOptions } from 'state/unified-menu/use-menu-query-options';
import { isProductRouteMenuEntry } from 'state/unified-menu/utils';
import { logger } from 'utils/logger';

// new - one menu
export const MenuProductPage = () => {
  useMenuScroll();
  const isMinimalCartUIEnabled = useMinimalCartUi();
  const { indexedMenu, isLoading } = useUnifiedMenuContext();
  const { posServiceMode } = useMenuQueryOptions();

  const { pathname, params } = useRoute<{ id: string; cartIdEditing: string }>();
  const { id = '', cartIdEditing = '' } = params || {};

  const { cartEntries: legacyCartEntries } = useCart();
  const { cartEntries } = useMinimalCart();

  const menuObject = indexedMenu.find(id);
  const menuObjectType = String(menuObject?.type);

  // TODO: determine how we'll manage loading
  const { error: menuObjectError } = {
    error: null,
  };

  useLogMenuContent({
    loggedValues: {
      id,
      name: menuObject?.name?.locale ?? '',
      menuType: menuObjectType,
    },
    pathname,
  });

  // TODO: implement useHandleMenuItemInOffer
  if (isLoading) {
    return (
      <CardModal noDesktopWebMaxWidth>
        <MenuProductSkeleton type={menuObjectType} />
      </CardModal>
    );
  }

  // TODO: implement isOffer
  const isOffer = false;
  const isProductRouteEntry = menuObject && isProductRouteMenuEntry(menuObject, posServiceMode);

  if (menuObject && !isProductRouteEntry) {
    logger.warn({
      message: '[MenuProductPage] blocked non-standalone One Menu product route',
      context: {
        id,
        name: menuObject.name?.locale,
        type: menuObject.type,
        posServiceMode,
      },
    });
  }

  if (!menuObject || menuObjectError || !isProductRouteEntry) {
    return (
      <CardModal alwaysHideHeader noDesktopWebMaxWidth>
        <MenuItemUnavailable isOffer={isOffer} />
      </CardModal>
    );
  }

  const editingCartEntry = isMinimalCartUIEnabled
    ? cartEntries.find(x => x.cartId === cartIdEditing)
    : legacyCartEntries.find(x => x.cartId === cartIdEditing);

  return (
    <CardModal testID="menu-product-page" noDesktopWebMaxWidth hasInternalFooter>
      <ProductWizardProvider menuObject={menuObject} editingCartEntry={editingCartEntry}>
        <ProductDetail />
      </ProductWizardProvider>
    </CardModal>
  );
};
